import React from 'react';
import {
    Button, Row, Col, Spinner,
} from 'reactstrap';
import { getShort } from '@s20/common/util/date';
import { httpClient } from '@s20/services/httpClient';
import { Can } from '../Can';
import { SmallButton } from '../common/forms/FormElements';
import { ApiRoutes } from '../Common';
import { LongTermStatusType } from '../longTermStatus/LongTermStatus';

export class EquipmentLongTermStatusInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            longTermStatuses: [],
        };
    }

    componentDidMount() {
        this.populateState();
    }

    getLongTermStatusName = (equipmentLongTermStatus) => {
        if (!equipmentLongTermStatus) {
            return '';
        }

        const { longTermStatuses } = this.state;

        const longTermStatus = longTermStatuses.find(
            (l) => l.id == equipmentLongTermStatus.longTermStatusId,
        );

        return longTermStatus.name;
    };

    async populateState() {
        const [longTermStatuses] = await Promise.all([
            httpClient.js(ApiRoutes.longTermStatus.byTypeId(LongTermStatusType.Equipment)),
        ]);

        this.setState({ longTermStatuses, loading: false });
    }

    render() {
        const { equipmentLongTermStatuses } = this.props;

        if (this.state.loading) {
            return (
                <Spinner />
            );
        }

        return (
            <>
                <Row className="pb-1">
                    <Col>
                        <div className="d-flex flex-row align-items-center justify-content-end">
                            <Can
                                I="edit"
                                a="equipment"
                            >
                                <SmallButton
                                    type="button"
                                    onClick={
                                        this.props
                                            .onAddEquipmentLongTermStatus
                                    }
                                >
                                    <i className="fa fa-plus-circle fa-md mr-2" />
                                    Add Long-Term Status
                                </SmallButton>
                            </Can>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <table className="table table-sm table-bordered">
                            <thead className="text-muted">
                                <tr>
                                    <th>Name</th>
                                    <th>Effective Date</th>
                                    <th>Expiration Date</th>
                                    <Can
                                        I="edit"
                                        a="equipmentlongtermstatus"
                                    >
                                        <th
                                            className="text-center"
                                            style={{ width: '30px' }}
                                        />
                                    </Can>
                                </tr>
                            </thead>
                            <tbody>
                                {!(equipmentLongTermStatuses ?? []).length ? (
                                    <tr>
                                        <td
                                            colSpan="4"
                                            className="text-center"
                                        >
                                            No long term statuses found.
                                        </td>
                                    </tr>
                                ) : (
                                    equipmentLongTermStatuses.map(
                                        (selectedEquipmentLongTermStatus) => {
                                            const longTermStatusName = this.getLongTermStatusName(
                                                selectedEquipmentLongTermStatus,
                                            );

                                            return (
                                                <tr
                                                    key={
                                                        selectedEquipmentLongTermStatus.id
                                                    }
                                                >
                                                    <td>
                                                        {longTermStatusName}
                                                    </td>
                                                    <td>
                                                        {getShort(
                                                            selectedEquipmentLongTermStatus.startDate,
                                                        )}
                                                    </td>
                                                    <td>
                                                        {getShort(
                                                            selectedEquipmentLongTermStatus.endDate,
                                                        ) ?? 'Current'}
                                                    </td>
                                                    <Can
                                                        I="edit"
                                                        a="equipmentlongtermstatus"
                                                    >
                                                        <td>
                                                            <Button
                                                                type="button"
                                                                color="outline-primary"
                                                                onClick={() => this.props.onEditEquipmentLongTermStatus(
                                                                    selectedEquipmentLongTermStatus,
                                                                )}
                                                                size="sm"
                                                            >
                                                                Edit
                                                            </Button>
                                                        </td>
                                                    </Can>
                                                </tr>
                                            );
                                        },
                                    )
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </>
        );
    }
}
